export default [
    {name: 'Kandy', value: "Kandy"},
    {name: 'Galle', value: "Galle"},
    {name: 'Colombo', value: "Colombo"},
    {name: 'Embilipitiya', value: "Embilipitiya"}
];


// WEBPACK FOOTER //
// ./src/data/towns.js